import React, { useState, useEffect } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { handleWheel, handleMouseEnter, handleMouseLeave } from '../utils/Scroll';
import DashboardReports from "../pages/DashboardReports";

const Dashboard = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [showReports, setShowReports] = useState(true);

    const location = useLocation();
    const navigate = useNavigate();

    // ✅ GET & CLEAN ROLES (trim all whitespace)
    const roles = (JSON.parse(localStorage.getItem("roles")) || [])
        .map(role => role.trim());

    // ✅ STRICT PERMISSION CHECK
    const hasPermission = (permission) => roles.includes(permission.trim());

    // ✅ MENU CONFIG WITH EXACT MANAGEMENT PERMISSIONS
    const menuItems = [
        {
            name: "Dashboard",
            path: "/dashboard",
            icon: "https://img.icons8.com/?size=100&id=S5D5w5vFLhYp&format=png&color=228BE6",
            permission: "Dashboard Data Listing - Management"
        },
        {
            name: "Add Customer",
            path: "add-customer",
            icon: "https://img.icons8.com/?size=100&id=8953&format=png&color=228BE6",
            permission: "Customer List & Create - Management"
        },

        {
            name: "Add Appointment",
            path: "add-appointment",
            icon: "https://img.icons8.com/?size=100&id=10239&format=png&color=228BE6",
            permission: "Create Appointment Range - Management"
        },
        {
            name: "AI Chats",
            path: "whatsappchat",
            icon: "https://img.icons8.com/?size=100&id=37628&format=png&color=228BE6",
            permission: "WhatsApp Chat - Management"
        },
        {
            name: "Appointments",
            path: "appointment",
            icon: "https://img.icons8.com/?size=100&id=26063&format=png&color=228BE6",
            permission: "All Appointments - Management"
        },
        {
            name: "Timeline",
            path: "appointment-timeline",
            icon: "https://img.icons8.com/?size=100&id=13238&format=png&color=000000",
            permission: "Employee Timeline - Management"
        },
        {
            name: "Broadcast Message",
            path: "broadcast-message",
            icon: "https://img.icons8.com/?size=100&id=11458&format=png&color=228BE6",
            permission: "Send WhatsApp Bulk - Management"
        },
        {
            name: "WA Appointment",
            path: "whatsapp-appointment",
            icon: "https://img.icons8.com/?size=100&id=60430&format=png&color=228BE6",
            permission: "WhatsApp Appointments - Management"
        },
        {
            name: "Transactions",
            path: "transactions",
            icon: "https://img.icons8.com/?size=100&id=PZtTHBz3UAFk&format=png&color=228BE6",
            permission: "Payment Transactions - Management"
        },
        {
            name: "Payment Details",
            path: "payment-details",
            icon: "https://img.icons8.com/?size=100&id=7994&format=png&color=228BE6",
            permission: "Payment Transactions - Management"
        },
        {
            name: "Payment Links",
            path: "payment",
            icon: "https://img.icons8.com/?size=100&id=EWekelGFX1OO&format=png&color=228BE6",
            permission: "Payment Link - Management"
        },
        {
            name: "Blog",
            path: "auth-blog",
            icon: "https://img.icons8.com/?size=100&id=v7EoCByoU6rv&format=png&color=228BE6",
            permission: "Blogs List - Management"
        },
        {
            name: "URL Permission",
            path: "url_permission",
            icon: "https://img.icons8.com/?size=100&id=10475&format=png&color=228BE6",
            permission: "URL Permissions Handle - Management"
        },
        {
            name: "Add Employee",
            path: "add-employee",
            icon: "https://img.icons8.com/?size=100&id=hfMDLJ5tX5Ey&format=png&color=228BE6",
            permission: "Add Employee AllUser - Management"
        },
        {
            name: "Manage Partner",
            path: "manage-partner",
            icon: "https://img.icons8.com/?size=100&id=sHhyuPYJ5otp&format=png&color=000000",
            permission: "Manage Partner Employee - Management"
        },

          {
            name: "Manage Salary",
            path: "manage-salary",
            icon: "https://img.icons8.com/?size=100&id=82688&format=png&color=228BE6",
            permission: "Manage Salary - Management"
        },

            {
            name: "Manage Packages",
            path: "manage-packages",
            icon: "https://img.icons8.com/?size=100&id=CtwLSt2ZT9Mo&format=png&color=228BE6",
            permission: "Manage Packages - Management"
        },

        {
            name: "Manage Promotions",
            path: "manage-promotions",
            icon: "https://img.icons8.com/?size=100&id=8VTkUyx94KS7&format=png&color=228BE6",
            permission: "Manage Promotions - Management"
        },

        {
            name: "Employee Feedback",
            path: "employee-feedback",
            icon: "https://img.icons8.com/?size=100&id=HMO1TRQkstaj&format=png&color=228BE6",
            permission: "Employee Feedback - Management"
        },
          {
            name: "Employee Day Off",
            path: "employee-dayoff",
            icon: "https://img.icons8.com/?size=100&id=62478&format=png&color=228BE6",
            permission: "Employee Day Off - Management"
        },

      
    ];

    // ✅ SHOW DASHBOARD REPORTS ONLY ON MAIN PAGE
    useEffect(() => {
        setShowReports(location.pathname === "/dashboard" || location.pathname === "/dashboard/");
    }, [location.pathname]);

    // ✅ AUTO-REDIRECT IF NO DASHBOARD PERMISSION
    useEffect(() => {
        const isDashboardRoot =
            location.pathname === "/dashboard" || location.pathname === "/dashboard/";

        if (isDashboardRoot && !hasPermission("Dashboard Data Listing - Management")) {
            const firstAllowed = menuItems.find(
                item => item.path !== "/dashboard" && hasPermission(item.permission)
            );
            if (firstAllowed) {
                navigate(firstAllowed.path, { replace: true });
            }
        }
    }, [location.pathname]);
    

    // ✅ RESPONSIVE
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (windowWidth >= 768) setSidebarOpen(false);
    }, [windowWidth]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    // ✅ TOKEN VALIDATION
    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/");
            return;
        }

        try {
            const payload = JSON.parse(atob(token.split(".")[1]));
            const isExpired = payload.exp * 1000 < Date.now();

            if (isExpired) {
                localStorage.clear();
                navigate("/");
            }
        } catch {
            localStorage.clear();
            navigate("/");
        }
    }, [navigate]);

    return (
        <div className="d-flex flex-column">
            <div className="d-flex flex-grow-1 overflow-hidden">

                {/* SIDEBAR */}
                <div
                    className={`sidebar position-fixed h-100 overflow-auto ${sidebarOpen || windowWidth >= 768 ? "d-block" : "d-none"
                        }`}
                    style={{ width: "280px", zIndex: 1000 }}
                >
                    <div
                        className="sidebar-content p-4"
                        onWheel={handleWheel}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        style={{ overflow: "hidden" }}
                    >
                        <div className="sidebar-header mb-4">
                            <h5 className="text-primary fw-bold mb-0">UNIVERSAL HRA</h5>
                            <small className="text-muted">Management Panel</small>
                        </div>

                        {/* ✅ PERMISSION BASED MENU */}
                        <ul className="nav flex-column gap-1 mb-2">
                            {menuItems
                                .filter(item => hasPermission(item.permission))
                                .map((item, index) => (
                                    <li key={index} className="nav-item">
                                        {item.path === "/dashboard" ? (
                                            <div
                                                onClick={() => navigate("/dashboard")}
                                                className="nav-link sidebar-link d-flex align-items-center gap-3 py-3 px-3 rounded-3"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <img src={item.icon} width="20" alt="" />
                                                <span className="fw-medium">{item.name}</span>
                                            </div>
                                        ) : (
                                            <Link
                                                to={item.path}
                                                className="nav-link sidebar-link d-flex align-items-center gap-3 py-3 px-3 rounded-3"
                                            >
                                                <img src={item.icon} width="20" alt="" />
                                                <span className="fw-medium">{item.name}</span>
                                            </Link>
                                        )}
                                    </li>
                                ))}

                            {/* EXIT */}
                            <li className="nav-item">
                                <Link
                                    to="/"
                                    className="nav-link sidebar-link d-flex align-items-center gap-3 py-3 px-3 rounded-3"
                                >
                                    <img src="https://img.icons8.com/?size=100&id=10809&format=png&color=228BE6" width="20" alt="exit" />
                                    <span className="fw-medium">Exit Panel</span>
                                </Link>
                            </li>

                            {/* LOGOUT */}
                            <li className="nav-item mb-5">
                                <div
                                    onClick={() => {
                                        localStorage.clear();
                                        window.location.href = "/";
                                    }}
                                    className="nav-link sidebar-link d-flex align-items-center gap-3 py-3 px-3 rounded-3"
                                    style={{ cursor: "pointer" }}
                                >
                                    <img src="https://img.icons8.com/?size=100&id=8119&format=png&color=228BE6" width="20" alt="logout" />
                                    <span className="fw-medium">Logout</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* MAIN CONTENT */}
                <div
                    className="bg-white"
                    style={{
                        marginLeft: windowWidth >= 768 ? "280px" : "0",
                        width: "100%",
                        overflowY: "auto"
                    }}
                >
                    {showReports
                        ? hasPermission("Dashboard Data Listing - Management")
                            ? <DashboardReports />
                            : (
                                <div
                                    className="d-flex flex-column align-items-center justify-content-center text-center"
                                    style={{ height: "100vh" }}
                                >
                                    <img
                                        src="https://img.icons8.com/?size=100&id=10475&format=png&color=dc3545"
                                        width="60"
                                        alt="forbidden"
                                    />
                                    <h4 className="text-danger mt-3">Access Denied</h4>
                                    <p className="text-muted">
                                        You don't have permission to view the Dashboard.
                                    </p>
                                    <p className="text-muted small">Redirecting you...</p>
                                </div>
                            )
                        : <Outlet />
                    }
                </div>

            </div>
        </div>
    );
};

export default Dashboard;